export default ($el) => {
    if ($el.$name) {
        return $el.$name;
    }

    return $el.$name = $el.dataset.componentName ?? null;
};